/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const PeopleAlt = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16 7.5C17.3807 7.5 18.5 6.38071 18.5 5C18.5 3.61929 17.3807 2.5 16 2.5C14.6193 2.5 13.5 3.61929 13.5 5C13.5 6.38071 14.6193 7.5 16 7.5ZM16 9C18.2091 9 20 7.20914 20 5C20 2.79086 18.2091 1 16 1C13.7909 1 12 2.79086 12 5C12 7.20914 13.7909 9 16 9ZM14.5 11C12.2909 11 10.5 12.7909 10.5 15V19.6619C10.5 19.8745 10.6162 19.9806 10.7055 20.0109C11.9716 20.441 14.0158 21 16 21C17.9842 21 20.0284 20.441 21.2945 20.0109C21.3838 19.9806 21.5 19.8745 21.5 19.6619V15C21.5 12.7909 19.7091 11 17.5 11H14.5ZM14.5 9.5C11.4624 9.5 9 11.9624 9 15V19.6619C9 20.4568 9.47035 21.1755 10.223 21.4312C11.5487 21.8815 13.7743 22.5 16 22.5C18.2257 22.5 20.4513 21.8815 21.777 21.4312C22.5297 21.1755 23 20.4568 23 19.6619V15C23 11.9624 20.5376 9.5 17.5 9.5H14.5ZM7.5 8.5C8.60457 8.5 9.5 7.60457 9.5 6.5C9.5 5.39543 8.60457 4.5 7.5 4.5C6.39543 4.5 5.5 5.39543 5.5 6.5C5.5 7.60457 6.39543 8.5 7.5 8.5ZM7.5 10C9.433 10 11 8.433 11 6.5C11 4.567 9.433 3 7.5 3C5.567 3 4 4.567 4 6.5C4 8.433 5.567 10 7.5 10ZM8.97582 10.7003C8.50617 10.5698 8.01123 10.5 7.5 10.5H6.5C3.46243 10.5 1 12.9624 1 16V18.8905C1 19.6888 1.47475 20.4106 2.23414 20.6569C3.38553 21.0304 5.19277 21.5 7 21.5C7.33499 21.5 7.66997 21.4839 8.00079 21.4552C7.73031 21.0111 7.56415 20.5064 7.51521 19.9859C7.34333 19.9951 7.17134 20 7 20C5.42109 20 3.78632 19.5834 2.69692 19.2301C2.61776 19.2044 2.5 19.1061 2.5 18.8905V16C2.5 13.7909 4.29086 12 6.5 12H7.5C7.72098 12 7.93778 12.0179 8.14901 12.0524C8.37364 11.5692 8.65178 11.116 8.97582 10.7003Z"
                        fill={color}
                    />
                </svg>
        );
    };
